var _objectWithoutProperties = require("/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-gap: 10px 10px;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  grid-template-rows: auto;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: ", ";\n\n  > * {\n    margin-right: 10px;\n    margin-bottom: 5px;\n  }\n\n  > *:last-child {\n    margin-right: 0px;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  opacity: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  display: ", ";\n  width: ", ";\n  ", ";\n  padding: 18px 30px;\n  white-space: nowrap;\n  word-break: keep-all;\n  border: none;\n  border-radius: ", ";\n  border-bottom-width: ", ";\n  border-bottom-style: solid;\n\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  background: none;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n  text-decoration: none;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  border-bottom-color: ", ";\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n    border-bottom-color: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  ", ";\n  align-self: center;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  border-bottom-color: ", ";\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n    border-bottom-color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  border-bottom-color: ", ";\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n    border-bottom-color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &:disabled {\n    cursor: not-allowed;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types'), require('styled-components'), require('@rtm-ui/layout'), require('@rtm-ui/tracker'), require('@rtm-ui/typography'), require('@rtm-ui/theme')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'styled-components', '@rtm-ui/layout', '@rtm-ui/tracker', '@rtm-ui/typography', '@rtm-ui/theme'], factory) : (global = global || self, factory(global.button = {}, global.React, global.PropTypes, global.styled, global.RtmUiLayout, global.RtmUiTracker, global.RtmUiTypography, global.RtmUiTheme));
})(this, function (exports, React, PropTypes, styled, layout, tracker, typography, theme) {
  'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;
  var styled__default = 'default' in styled ? styled['default'] : styled;

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var base = styled.css(_templateObject());
  var primary = styled.css(_templateObject2(), function (props) {
    return theme.getColor('inverseText', props.theme);
  }, function (props) {
    return theme.getColor('accent', props.theme);
  }, function (props) {
    return theme.tintColor(theme.getColor('accent', props.theme), -10);
  }, function (props) {
    return theme.getColor('inverseText', props.theme);
  }, function (props) {
    return theme.tintColor(theme.getColor('accent', props.theme), -5);
  }, function (props) {
    return theme.tintColor(theme.getColor('accent', props.theme), -10);
  });
  var secondary = styled.css(_templateObject3(), function (props) {
    return props.theme.colors.grayscale.white;
  }, function (props) {
    return props.theme.colors.grayscale.slightlyDarker;
  }, function (props) {
    return props.theme.colors.grayscale.darker;
  }, function (props) {
    return props.theme.colors.grayscale.white;
  }, function (props) {
    return props.theme.colors.grayscale.darker;
  }, function (props) {
    return props.theme.colors.grayscale.slightlyDarker;
  });
  var contentStyling = styled.css(_templateObject4(), function (props) {
    return props.block ? 'flex' : 'inline-flex';
  }, function (props) {
    return props.block && 'flex: 1';
  });
  var ContentWrapper = styled__default(layout.Box)(_templateObject5(), contentStyling);
  var tertiary = styled.css(_templateObject6(), function (props) {
    return theme.getColor('inverseText', props.theme);
  }, function (props) {
    return theme.getColor('tertiary', props.theme);
  }, function (props) {
    return theme.tintColor(theme.getColor('tertiary', props.theme), -5);
  }, function (props) {
    return theme.getColor('inverseText', props.theme);
  }, function (props) {
    return theme.tintColor(theme.getColor('tertiary', props.theme), -5);
  }, function (props) {
    return theme.tintColor(theme.getColor('tertiary', props.theme), -10);
  });
  var resetStyling = styled.css(_templateObject7());
  var buttonStyling = styled.css(_templateObject8(), resetStyling, base, typography.labelTextStyles, function (props) {
    return props.block ? 'block' : 'inline-block';
  }, function (props) {
    return props.width || 'inherit';
  }, function (props) {
    return props.block && 'flex: 1';
  }, function (props) {
    return props.theme.button.borderRadius;
  }, function (props) {
    return props.theme.button.bottomBorderWidth;
  }, function (props) {
    return props.tertiary ? tertiary : props.secondary ? secondary : primary;
  });
  var ButtonLink = styled__default.a(_templateObject9(), buttonStyling, contentStyling);
  var StyledButton = styled__default.button(_templateObject10(), buttonStyling, function (props) {
    return props.appearDisabled === true ? '0.5' : '1';
  });
  var WrapperButton = styled__default.button(_templateObject11(), resetStyling);
  var WrapperLink = styled__default.a(_templateObject12(), resetStyling);
  ButtonLink.propTypes = {
    block: PropTypes.bool
  };

  var Base = function Base(_ref) {
    var track = _ref.track,
        _onClick = _ref.onClick,
        children = _ref.children,
        asWrapper = _ref.asWrapper,
        block = _ref.block,
        buttonProps = _objectWithoutProperties(_ref, ["track", "onClick", "children", "asWrapper", "block"]);

    var _tracker$useTracker = tracker.useTracker(),
        ref = _tracker$useTracker.ref,
        trackEvent = _tracker$useTracker.trackEvent;

    var Component = asWrapper ? WrapperButton : buttonProps.as === 'a' ? ButtonLink : StyledButton;
    var content = asWrapper || buttonProps.as === 'a' ?
    /*#__PURE__*/
    React.createElement(React.Fragment, null, children) :
    /*#__PURE__*/
    React.createElement(ContentWrapper, null, children);
    return (
      /*#__PURE__*/
      React.createElement(Component, _extends({
        ref: ref,
        block: block,
        onClick: function onClick(e) {
          return trackEvent(e, track, _onClick);
        }
      }, buttonProps), content)
    );
  };

  Base.propTypes = {
    track: PropTypes.string,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    block: PropTypes.bool,
    asWrapper: PropTypes.bool
  };
  var GroupWrapper = styled__default.div(_templateObject13(), function (props) {
    return props.flexWrap || 'wrap';
  });
  var ButtonGrid = styled__default(layout.Box)(_templateObject14());

  var ButtonGroup = function ButtonGroup(_ref2) {
    var children = _ref2.children,
        flexProps = _objectWithoutProperties(_ref2, ["children"]);

    return (
      /*#__PURE__*/
      React.createElement(GroupWrapper, flexProps, children)
    );
  };

  var Button = function Button(props) {
    return (
      /*#__PURE__*/
      React.createElement(Base, props)
    );
  };

  ButtonGroup.propTypes = {
    children: PropTypes.node.isRequired
  };
  Button.propTypes = {
    track: PropTypes.string,
    children: PropTypes.node.isRequired,
    type: PropTypes.oneOf(['submit', 'reset', 'button']),
    onClick: PropTypes.func,
    asWrapper: PropTypes.bool,
    block: PropTypes.bool,
    secondary: PropTypes.bool,
    appearDisabled: PropTypes.bool
  };
  exports.Button = Button;
  exports.ButtonGrid = ButtonGrid;
  exports.ButtonGroup = ButtonGroup;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});